/**
 */
export default class GameOptions {
    constructor() {

        /**
         * @type {boolean}
         */
        this.crewBrainDebugEnabled = false;

        /**
         * @type {number}
         */
        this.maxFps = -1;

        /**
         * @type {boolean}
         */
        this.displayFps = false;


        // it looks like we need dynamic lighting, otherwise tiles do not get seen.
        // /**
        //  * @type {boolean}
        //  */
        // this.dynamicLightingEnabled = true;
        /**
         * @type {boolean}
         */
        this.effectsRenderingEnabled = true;
        /**
         * @type {boolean}
         */
        this.depthColumnRendered = true;
        /**
         * @type {boolean}
         */
        this.wireframeModeEnabled = false;
    }

    /**
     * The fps threshold in millis (for use by the GameLoop)
     * @returns {number}
     */
    getFpsMillis() {
        if (this.maxFps <= 0) {
            return 1000 / 250;
        }

        return 1000 / this.maxFps;
    }
}